var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout2 = function SvgLogout2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#171926;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-23882 -22437)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23882 22437)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23876 -22433.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.2,0h-10a4.012,4.012,0,0,0-4,4V20a4.011,4.011,0,0,0,4,4h10a4.011,4.011,0,0,0,4-4V4A4.012,4.012,0,0,0,65.2,0Zm2,20a2,2,0,0,1-2,2h-10a2,2,0,0,1-2-2V13h8.585L59.2,15.586,60.613,17l4.293-4.293a1,1,0,0,0,0-1.414L60.613,7,59.2,8.413,61.785,11H53.2V4a2,2,0,0,1,2-2h10a2,2,0,0,1,2,2Z",
    transform: "translate(-51.2)"
  }))))));
};
export default SvgLogout2;